import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { LocalStorageService } from '@coreui/angular-pro';
import { RestProvider } from './rest.service';
import { CustomerModel, UserProfileModel } from '../models/user-cust-model';
import { Router } from '@angular/router';
import { PermissionsProvider } from './permission.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ApiHandlerService } from './api-handler.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public static COOKIE_TOKEN_NAME = 'access-token';
  public token: string | null = null;
  public USER_KEY = 'user'
  public TOKEN_KEY = 'access_token';

  private userSubject = new BehaviorSubject<UserProfileModel | null>(null);
  public user$ = this.userSubject.asObservable();

  private customerSubject = new BehaviorSubject<CustomerModel | null>(null);
  public customer$ = this.customerSubject.asObservable();


  constructor(
    private cookieService: CookieService,
    private storage: LocalStorageService,
    private restProvider: RestProvider,
    private apiHandler: ApiHandlerService,
    private router: Router,
    private permissionService: PermissionsProvider
  ) { }

  async getAuthCookie() {
    const _token = environment.developmentAccessToken ?
    environment.developmentAccessToken :
    this.cookieService.get(AuthService.COOKIE_TOKEN_NAME);
    return _token;
  }

  public async ssoFlow() {
    const hasAccessToken = await this.checkToken();
    if (!hasAccessToken) {
      // console.log(`Redirect to SSO Login: ${environment.ssoAuthUrl}login/?redirect_url=${environment.webAppUrl}/login`)
      window.location.replace(`${environment.ssoAuthUrl}login/?redirect_url=${environment.webAppUrl}`);
      // Redirect to http://dashboard.datalive-staging.com/oauth2/login?redirect_url=https://checkit.datalive-staging.com/login
    }

    // this.events.userLogout.next(false);
  }

  async checkToken(): Promise<boolean> {
    const user = await this.getOrSetUser();
    const token = await this.getAuthCookie();

    if (token) {
      this.setToken(token);
      return this.getAndSetUser(user)
    }

    return false;
  }

  private async getAndSetUser(user: any): Promise<boolean> {
    if (user) {
      this.setUserData(user)
      return true;
    } else {
      try {
        const user = await this.restProvider.getUserInfo();
        this.setUserData(user);
        return true;
      } catch (error) {
        // console.log('login error getting user date: ', error)
        return false;
      }
    }
  }

  private setUserData(userData: any) {
    this.userSubject.next(userData);
    this.storage.setItem(this.USER_KEY, this.userSubject.getValue());

    // Set permissions
    this.permissionService.LoadRole(userData.permission);
    this.permissionService.LoadModulePermissions(userData.modules);

    // check external app permission here

    this.getAndSetCustomerState()
  }

  private async getAndSetCustomerState() {
    const customer = await this.restProvider.GetCurrentUser();
    this.customerSubject.next(customer);
  }

  private setToken(token: string) {
    this.token = token;
    this.apiHandler.token = token;
    this.restProvider.token = token;
  }

  getOrSetUser(): any {
    let user = this.storage.getItem(this.USER_KEY);

    if (user) {
      this.storage.removeItem(this.USER_KEY);
      user = null;
    }

    return user;
  }

}
